<template>
  <n-modal
    :show="show"
    preset="card"
    :title="$t('configuracion_modificar_clave')"
    :style="{ width: '420px' }"
    :bordered="true"
    :segmented="{ content: true }"
    @update:show="$emit('update:show', $event)"
  >
    <n-spin :show="loading">
      <div class="change-password-form">
        <div class="form-row">
          <label class="form-label">{{ $t("configuracion_clave_actual") }}</label>
          <n-input
            v-model:value="form.claveActual"
            type="password"
            :placeholder="$t('configuracion_clave_actual')"
            show-password-on="click"
            class="form-input"
          />
        </div>
        <div class="form-row">
          <label class="form-label">{{ $t("configuracion_nueva_clave") }}</label>
          <n-input
            v-model:value="form.nuevaClave"
            type="password"
            :placeholder="$t('configuracion_nueva_clave')"
            show-password-on="click"
            class="form-input"
          />
        </div>
        <div class="form-row">
          <label class="form-label">{{ $t("configuracion_confirmar_clave") }}</label>
          <n-input
            v-model:value="form.confirmarClave"
            type="password"
            :placeholder="$t('configuracion_confirmar_clave')"
            show-password-on="click"
            class="form-input"
          />
        </div>
        <p v-if="errorMsg" class="error-msg">{{ errorMsg }}</p>
        <div class="form-actions">
          <button type="button" class="primary-button" @click="onAceptar" :disabled="loading">
            {{ $t("aceptar") }}
          </button>
          <button type="button" class="primary-button" @click="onCancelar" :disabled="loading">
            {{ $t("cancelar") }}
          </button>
        </div>
      </div>
    </n-spin>
  </n-modal>
</template>

<script setup>
import { reactive, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { NModal, NInput, NSpin } from "naive-ui";
import { useAuthStore } from "@/stores/auth";

function getTokenTempPassword(cliente) {
  let token = "*";
  const codigo = String(cliente || "").replace(/^0+/, "");
  if (codigo.length > 0) {
    token += codigo.charAt(0);
    token += codigo.charAt(codigo.length - 1);
  }
  const now = new Date();
  const actualHour = now.getHours();
  const actualMonth = now.getMonth() + 1;
  now.setDate(now.getDate() - 1);
  const yesterday = now.getDate();
  const num = Math.abs(actualHour - yesterday + actualMonth);
  return `${token}${num}`;
}

const props = defineProps({
  show: { type: Boolean, default: false },
  username: { type: String, default: "" },
  tempPassword: { type: String, default: "" },
});

const emit = defineEmits(["update:show", "success", "cancel"]);

const authStore = useAuthStore();
const { t } = useI18n();

const form = reactive({
  claveActual: "",
  nuevaClave: "",
  confirmarClave: "",
});
const errorMsg = ref("");
const loading = ref(false);

watch(
  () => props.show,
  (val) => {
    if (val) {
      form.claveActual = "";
      form.nuevaClave = "";
      form.confirmarClave = "";
      errorMsg.value = "";
    }
  },
);

function onCancelar() {
  emit("cancel");
  emit("update:show", false);
}

function isValidNewPassword(pwd) {
  return pwd.length >= 8;
}

async function onAceptar() {
  errorMsg.value = "";
  if (!isValidNewPassword(form.nuevaClave)) {
    errorMsg.value = t("contrasena_minimo_8_caracteres");
    return;
  }
  if (form.nuevaClave !== form.confirmarClave) {
    errorMsg.value = t("las_contrasenas_no_coinciden");
    return;
  }
  if (form.claveActual !== props.tempPassword) {
    errorMsg.value = t("clave_actual_no_es_la_recibida_por_correo");
    return;
  }
  loading.value = true;
  try {
    const result = await authStore.CambiarContrasena({
      cliente: props.username,
      actual: getTokenTempPassword(props.username),
      nueva: form.nuevaClave,
    });
    if (result === true) {
      emit("success");
      emit("update:show", false);
    } else {
      errorMsg.value =
        result?.MensajeErrorSAP ||
        t("error_al_cambiar_la_contrasena_por_favor_verifica_tus_datos");
    }
  } catch (e) {
    errorMsg.value =
      e?.message || t("error_al_cambiar_la_contrasena_por_favor_verifica_tus_datos");
  }
  loading.value = false;
}
</script>

<style lang="scss" scoped>
.change-password-form {
  @apply flex flex-col gap-4;
}

.form-row {
  @apply flex flex-col gap-1;
}

.form-label {
  @apply text-sm font-bold text-rst_secondary;
}

.form-input {
  @apply w-full;
}

.error-msg {
  @apply text-sm text-red;
}

.form-actions {
  @apply flex gap-3 justify-end mt-2;
}
</style>
